import api from './api';

const CategoriesService = {
  // Get all categories
  getAllCategories: () => {
    return api.get('/category/list');
  },
  
  
  // Get category by ID
  getCategoryById: (categoryId) => {
    return api.get(`/category/${categoryId}`);
  },
  
  // Get trending categories
  getTrendingCategories: () => {
    return api.get('/category/trending');
  },
  
  // Get posts by category ID
  getPostsByCategory: (categoryId, params = {}) => {
    return api.get(`/posts/category/${categoryId}`, { params });
  },
  
  // Add user's favorite category
  addFavoriteCategory: (userId, categoryId) => {
    return api.post(`/users/${userId}/categories/favorite`, { categoryId });
  },
  
  // Remove user's favorite category
  removeFavoriteCategory: (userId, categoryId) => {
    return api.delete(`/users/${userId}/categories/favorite/${categoryId}`);
  },
  
  // Get user's favorite categories
  getUserFavoriteCategories: (userId) => {
    return api.get(`/users/${userId}/categories/favorite`);
  },
  
  // Search categories by name
  searchCategories: (query) => {
    return api.get('/categories/search', { params: { query } });
  }
};

export default CategoriesService;
